import React from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

import { theme } from './theme';

const useStyles = makeStyles<Theme>({
  blur: {
    zIndex: -1,
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: 'rgba(0, 160, 200, 0.1)',
    filter: 'blur(100px)',
  },
  topRightCircle: {
    position: 'fixed',
    right: 0,
    top: 0,
    transform: 'translate(15%, -15%)',
    background: theme.palette.secondary.main,
    width: theme.spacing(25),
    height: theme.spacing(25),
    borderRadius: '50%',
    opacity: 0.66,
  },
  leftBottomCircle: {
    position: 'fixed',
    left: 0,
    bottom: 0,
    transform: 'translate(-15%, 15%)',
    background: theme.palette.primary.main,
    opacity: 0.33,
    width: theme.spacing(40),
    height: theme.spacing(40),
    borderRadius: '50%',
  },
});

export const Background = () => {
  const classes = useStyles();

  return (
    <div className={classes.blur}>
      <div className={classes.topRightCircle}></div>
      <div className={classes.leftBottomCircle}></div>
    </div>
  );
};

export default Background;
